import axios, {AxiosResponse} from 'axios'
import {ID} from '@/_metronic/helpers'
import {
  SponsorshipsQueryResponse
} from './_models'

const BASE_URL = '/p2c/sponsorship'

const getSponsorships = (query: string): Promise<SponsorshipsQueryResponse> => {
  return axios
    .get(`${BASE_URL}?${query}`)
    .then((d: AxiosResponse<SponsorshipsQueryResponse>) => {
      return d.data
    })
}

const updateSponsorship = (customerId: ID, key: string, status: string, commission: number): Promise<void> => {
  return axios.put(`${BASE_URL}`, {
    customerId,
    key,
    status,
    commission
  })
}

export {
  getSponsorships,
  updateSponsorship
}
